export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_daily_shop_job_position/create', params)
	},
	delete (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_daily_shop_job_position/delete', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_daily_shop_job_position/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_daily_shop_job_position/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/StaffDailyShopJobPosition.js